import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Paper, TablePagination } from '@material-ui/core';
import MaterialTable from 'material-table';

class Translation extends React.PureComponent {

  state = {
  
  }
 
  render() {
      const { data, t } = this.props;
     
      const freqs=  Object
                      .keys(data)
                      .map( trans => data[trans] )
                      .filter( f => f > 1 );
      const min=(freqs.length===0) ? 0:1;
      const tableRows = Object
                            .keys(data)
                            .map( trans => { return { translation:trans, freq:data[trans]} })
                            .filter( line => line.freq > min )
                            .sort( (a,b) => b.freq-a.freq );
      
      return (
        <>
        <div style={{width:"50%"}}>
        <MaterialTable
            title={t('translation')}
            columns={[
              { title: t('translation'), field: 'translation' },
              { title: t('frequency'), field: 'freq' }
            ]}
            data={tableRows}
            options={{
              filtering: true,
              search: true,
              sorting: true,
              exportButton: true,
              exportFile: 'translation',
              exportAlldata: true,
              rowStyle: {
                height:'30px',
              },
              padding: 'dense',
            }}
            components={{
              Pagination: props => (
                <TablePagination
                  {...props}
                  rowsPerPageOptions={[5, 10, 25, 50, 100, tableRows.length ]}
                />
              ),
              Container: props => (
                <Paper
                  {...props}
                  elevation={0}
                />
              ),
            }}
          />
        </div>

        </>
      );
  }
}

Translation.propTypes = {
  data: PropTypes.object,
};

export default withTranslation()(Translation);
